import { Dialog } from "@mui/material";
import * as React from "react";

import { RobotoButton } from "@/shared/components";
import { AddToCollection } from "@/shared/components/collections";
import { EventRecord } from "@/shared/domain/events";

interface AddEventToCollectionProps {
  eventId: EventRecord["event_id"];
}

export function AddEventToCollection({ eventId }: AddEventToCollectionProps) {
  const [open, setOpen] = React.useState(false);

  return (
    <>
      <RobotoButton
        eventName="WorkspaceEventAddToCollectionClicked"
        eventProperties={{ eventId }}
        variant="outlined"
        onClick={() => setOpen(true)}
      >
        Add to Collection
      </RobotoButton>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        data-not-draggable="true"
      >
        <AddToCollection
          selected={{ type: "Event", items: new Set([eventId]) }}
          onCancel={() => setOpen(false)}
        />
      </Dialog>
    </>
  );
}
